import { render, staticRenderFns } from "./NotificationCartsExpiringSoonModal.vue?vue&type=template&id=235031f1&"
import script from "./NotificationCartsExpiringSoonModal.vue?vue&type=script&lang=js&"
export * from "./NotificationCartsExpiringSoonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports